// extracted by mini-css-extract-plugin
export default {"main":"Client_main__L+9Jh"};